import LoadingButton from '@mui/lab/LoadingButton'

import withStyles from '@mui/styles/withStyles'

const Button = withStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    width: '148px',
    minHeight: '36px',
    background: theme.palette.primary.main,
    color: 'white',

    '&:hover': {
      background: '#9639AB'
    },

    '&:disabled': {
      color: 'lightgray !important',
      opacity: '0.5'
    }
  },

  text: {
    fontSize: theme.size.base,
    textTransform: 'none'
  }
}))(LoadingButton)

export default Button
